import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
// import { Link } from "react-router-dom";
// import InputLabel from "@mui/material/InputLabel";
// import MenuItem from "@mui/material/MenuItem";
// import FormControl from "@mui/material/FormControl";
// import Select from "@mui/material/Select";
// import Tooltip from "@mui/material/Tooltip";
import { HiSearch } from "react-icons/hi";
// import useAlertUtils, { getCookie } from "../../../utils/common.utils";
import { fetchData } from "../../../services/apiService";
import ReactPaginate from "react-paginate";
import useAlertUtils from "../../../utils/common.utils";
import { encryptData } from "../../../services/encryptionDecription.service";
// import Layout from "../Layouts/layout";
import Box from "@mui/material/Box";
// import CancelIcon from "@mui/icons-material/Cancel";
// import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import Header from "../../../components/Header/Header";
import Footer from "../../../components/Footer/Footer";
import BrokenImage from "../../../assets/img/Broken Img.jpg";
import CircularProgress from "@mui/material/CircularProgress";

function MyOrder() {
  // const toggle = () => setOpenCModal(!openCModal);

  // const closeBtn = (
  //   <button className="btn " onClick={toggle} type="button">
  //     &times;
  //   </button>
  // );
  // const token = getCookie("token");
  const navigate = useNavigate();
  const pageLoader = useState(false);
  const [status, setStatus] = useState(0);
  // const [results, setResults] = useState([]);
  const [pageCount, setPageCount] = useState(1);
  const [currentPage, setCurrentPage] = useState(0);
  const limit = 10;

  const [input, setInput] = useState("");
  // const [reportStatus, setReportStatus] = useState("");
  // const [message, setMessage] = useState();
  const { alertSuccess, alertError } = useAlertUtils();
  // const { alertSuccess, alertError } = useAlertUtils();
  const [resultData, setResultData] = useState([]);
  // const [openCModal, setOpenCModal] = useState(false);
  const [popular, setPopular] = useState({ men: [], women: [] });
  const [popularTab, setPopularTab] = useState("men"); // men | women
  const orderID = null;
  const orderType = null;
  const paymentType = "";
  const [open, setOpen] = useState(false);
  // const selectedCatalogId = useState(null);

  const [ordersLoading, setOrdersLoading] = useState(false);
  const [popularLoading, setPopularLoading] = useState(false);

  const fetchOrders = async (status = 0) => {
    try {
      setOrdersLoading(true);
      let results = await fetchData(
        `/api/catalog/order/getpatientOrder?page=${currentPage}&status=${status}&limit=${limit}&search=${btoa(
          encryptData(input)
        )}`
      );
      setResultData(results?.data?.data);
      setPageCount(results?.data?.totalPages);
    } catch (error) {
      alertError("Error Getting Patients Error");
    } finally {
      setOrdersLoading(false);
    }
  };

  // const closeCModal = () => {
  //   setOpenCModal(false);
  // };

  const handleStatusChange = (e) => {
    const orderstatus = e.target.value || 0;
    setStatus(orderstatus);
    fetchOrders(orderstatus);
    // setStatus(e.target.value)
    // setPageLoader(true)
    // getOrders(e.target.value, currentPage + 1)
  };

  // const handleModel = (orderID, type, paymentType) => {
  //   setOrderID(orderID);
  //   setOrderType(type);
  //   setPaymentType(paymentType);
  //   setOpenCModal(true);
  //   setOpen(true);
  // };

  const handleOrderApproval = async (orderId, type) => {
    // try {
    //   setPageLoader(true);
    //   if (type === 'SUBSCRIPTION') {
    //     await subscriptionOrderApproval(orderId);
    //   } else {
    //     await orderApproval(orderId);
    //   }
    //   alert.success('Order approved successfully');
    //   // Fetch or refresh the order list here if needed
    // } catch (err) {
    //   alert.error('Order approval failed');
    // } finally {
    //   setOpenCModal(false);
    //   setPageLoader(false);
    // }
  };

  const handleOrderCancellation = async (orderId, type) => {
    // try {
    //   setPageLoader(true);
    //   if (type === 'SUBSCRIPTION') {
    //     await subscriptionOrderCancelled(orderId);
    //   } else {
    //     await orderCancelled(orderId);
    //   }
    //   alert.success('Order cancelled successfully');
    //   // Fetch or refresh the order list here if needed
    // } catch (err) {
    //   alert.error('Order cancellation failed');
    // } finally {
    //   setOpenCModal(false);
    //   setPageLoader(false);
    // }
  };

  const fetchPopularProducts = async () => {
    try {
      setPopularLoading(true);
      const res = await fetchData(`/api/catalog/get-popular-products`);
      console.log(res);
      const men = res?.data?.men || [];
      const women = res?.data?.women || [];
      setPopular({
        men: Array.isArray(men) ? men : [],
        women: Array.isArray(women) ? women : [],
      });
    } catch (e) {
      setPopular({ men: [], women: [] });
    } finally {
      setPopularLoading(false);
    }
  };

  useEffect(() => {
    fetchOrders();
    fetchPopularProducts();
  }, [currentPage, input]);

  const handlePageClick = (event) => {
    const selectedPage = event.selected;
    setCurrentPage(selectedPage);
  };

  // Search Functionality
  function searchFunc() {
    fetchOrders(); // Call fetchOrders to apply the search input
  }

  const formatTimestamp = (timestamp) => {
    const date = new Date(timestamp);
    return date.toLocaleString(); // Or use any other formatting method you prefer
  };

  // const filterChange = (event) => {
  //   setInput("");
  //   setReportStatus(event.target.value);
  // };

  // const handleDelete = async () => {
  //   try {
  //     await deleteData(`/api/catalog/delete/${selectedCatalogId}`, "DELETE"); // Replace with actual delete API call
  //     alertSuccess("Catalog deleted successfully");
  //     setOpen(false);
  //     fetchOrders(); // Refresh the list after deletion
  //   } catch (error) {
  //     alertError("Error deleting catalog");
  //   }
  // };

  const handleView = (id) => {
    navigate(`/app/view-my-order/${id}`);
  };

  return (
    <>
      <Header />
      <div className="main_content">
        <div className="container">
          <div>
            <div className="main_block">
              <div className="top_bar">
                <div className="left_part">
                  <div className="main_title">Patient Order</div>
                </div>
                <div
                  className="right_part"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <div className="search_bar" style={{ marginRight: "20px" }}>
                    <div className="input-group">
                      <input
                        type="search"
                        value={input}
                        onChange={(e) => setInput(e.target.value)}
                        className="form-control"
                        placeholder="Search by Product"
                        aria-label="Search"
                      />
                      <button className="btn search-btn" onClick={searchFunc}>
                        <HiSearch size={20} />
                      </button>
                    </div>
                  </div>
                  <div className="status_dropdown">
                    <select
                      onChange={handleStatusChange}
                      className="form-control"
                      value={status}
                    >
                      <option value={0}>ALL</option>
                      <option value={1}>PENDING</option>
                      <option value={2}>APPROVED</option>
                      <option value={3}>COMPLETED</option>
                      <option value={4}>CANCELLED</option>
                    </select>
                  </div>
                </div>
              </div>
              <div className="table_wrapper dashboard">
                <div className="table_inner">
                  {ordersLoading ? (
                    <div style={{ padding: '40px 0', display: 'flex', justifyContent: 'center' }}>
                      <CircularProgress size={44} sx={{ color: '#e11d48' }} />
                    </div>
                  ) : (
                  <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                      <TableHead>
                        <TableRow>
                          <TableCell>SNo.</TableCell>
                          <TableCell align="right">Order ID</TableCell>
                          <TableCell align="right">Patient</TableCell>
                          <TableCell align="right">Product Name</TableCell>
                          <TableCell align="right">Quantity</TableCell>
                          <TableCell align="right">Total</TableCell>
                          <TableCell align="right">Payment Type</TableCell>
                          <TableCell align="right">Payment Status</TableCell>
                          <TableCell align="right">Order Status</TableCell>
                          <TableCell align="right">Order Date</TableCell>
                          <TableCell align="right">Action</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {resultData?.length > 0 &&
                          resultData?.map((row, index) => (
                            <TableRow key={row?.id}>
                              <TableCell align="right">{index + 1}</TableCell>
                              <TableCell align="right">
                                {row?.orderId}
                              </TableCell>
                              <TableCell align="right">
                                {row?.firstName}
                              </TableCell>
                              <TableCell align="right">
                                {row?.productTitle}
                              </TableCell>
                              <TableCell align="right">
                                {row?.quantity}
                              </TableCell>
                              <TableCell align="right">{row?.total}</TableCell>
                              <TableCell align="right">
                                {row?.type ? row?.type : "ONE TIME"}
                              </TableCell>
                              <TableCell>
                                <span
                                  className={
                                    row?.intent === "COMPLETED" ||
                                    row?.intent === "APPROVED"
                                      ? "badge bg-success"
                                      : row?.intent === "VOID" ||
                                        row?.intent === "CANCELLED"
                                      ? "badge bg-danger"
                                      : "badge bg-warning"
                                  }
                                >
                                  {row?.intent}
                                </span>
                              </TableCell>
                              <TableCell>
                                <span
                                  className={
                                    row?.status === 2
                                      ? "badge bg-success"
                                      : row?.status === 1 || row?.status === 3
                                      ? "badge bg-warning"
                                      : "badge bg-danger"
                                  }
                                >
                                  {row?.status === 1
                                    ? "PENDING"
                                    : row?.status === 2
                                    ? "APPROVED"
                                    : row?.status === 3
                                    ? "COMPLETED"
                                    : row?.status === 4
                                    ? "CANCELLED"
                                    : "UNKNOWN"}
                                </span>
                              </TableCell>
                              <TableCell>
                                {formatTimestamp(row?.orderCreatedAt)}
                              </TableCell>
                              <TableCell>
                                <Box>
                                  <Button
                                    variant="contained"
                                    onClick={() => handleView(row?.id)}
                                  >
                                    <span>View</span>
                                  </Button>
                                </Box>
                              </TableCell>

                              {/* {row?.status === 'PENDING' ? (
                            <TableCell style={{ display: "flex" }}>
                              <Box sx={{ '& button': { m: 1 } }}>
                                <Button
                                  variant='contained'
                                  size='small'
                                  startIcon={<CheckCircleIcon />}
                                  onClick={() => handleModel(row?.orderId, 'capture', row?.type)}
                                >
                                  Approve
                                </Button>
                              </Box>
                              <Box sx={{ '& button': { m: 1 } }}>
                                <Button
                                  variant='contained'
                                  size='small'
                                  startIcon={<CancelIcon />}
                                  onClick={() => handleModel(row?.orderId, 'cancel', row?.type)}
                                >
                                  Reject
                                </Button>
                              </Box>
                            </TableCell>
                          ) : null} */}
                            </TableRow>
                          ))}
                        {resultData?.length === 0 ? (
                          <TableRow>
                            <TableCell colSpan={11}>
                              <div className="notice">
                                <div className="alert">
                                  <span className="alertText">
                                    No Orders Found
                                  </span>
                                </div>
                              </div>
                            </TableCell>
                          </TableRow>
                        ) : null}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  )}
                </div>
              </div>
            </div>
          </div>

          <Modal isOpen={open} backdrop="static">
            <ModalHeader>Confirmation</ModalHeader>
            <ModalBody>
              <ModalBody>
                {orderType === "capture"
                  ? " Are you sure you want to approve this order and continue payment capture process?"
                  : "Are you sure you want to cancel this order?"}
              </ModalBody>
            </ModalBody>
            <ModalFooter>
              {orderType === "capture" ? (
                <>
                  <button
                    className="btn btn-info text-light"
                    disabled={pageLoader}
                    onClick={() => {
                      handleOrderApproval(orderID, paymentType);
                    }}
                  >
                    Approved
                  </button>

                  <button
                    className="btn btn-danger text-light"
                    onClick={() => {
                      setOpen(false);
                    }}
                  >
                    close
                  </button>
                </>
              ) : (
                <>
                  <button
                    className="btn btn-info text-light"
                    disabled={pageLoader}
                    onClick={() => {
                      handleOrderCancellation(orderID, paymentType);
                    }}
                  >
                    Cancel Order
                  </button>

                  <button
                    className="btn btn-danger text-light"
                    onClick={() => {
                      setOpen(false);
                    }}
                  >
                    close
                  </button>
                </>
              )}
            </ModalFooter>
          </Modal>
          <ReactPaginate
            breakLabel="..."
            nextLabel="next >"
            onPageChange={handlePageClick}
            pageRangeDisplayed={5}
            pageCount={pageCount}
            previousLabel="< previous"
            renderOnZeroPageCount={null}
            marginPagesDisplayed={2}
            containerClassName="pagination justify-content-center"
            pageClassName="page-item"
            pageLinkClassName="page-link"
            previousClassName="page-item"
            previousLinkClassName="page-link"
            nextClassName="page-item"
            nextLinkClassName="page-link"
            activeClassName="active"
          />

              <div
            className="popular-products-section"
            style={{
              marginTop: 40,
              marginBottom: 40,
              background: "#fff",
              borderRadius: 24,
              padding: "40px 24px",
            }}
          >
            <div
              style={{
                maxWidth: 1200,
                margin: "0 auto",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginBottom: 28,
                }}
              >
                <div>
                  <h2
                    style={{
                      margin: 0,
                      fontWeight: 800,
                      fontSize: 24,
                      color: "#111827",
                    }}
                  >
                    Popular Products
                  </h2>
                  <p style={{ color: "black", fontSize: 14, marginTop: 4 }}>
                    Curated bestsellers chosen by our clinical team
                  </p>
                </div>
              </div>

              {popularLoading ? (
                <div style={{ padding: '60px 0', display: 'flex', justifyContent: 'center' }}>
                  <CircularProgress size={44} sx={{ color: '#e11d48' }} />
                </div>
              ) : (
                <>
                  <div
                    style={{
                      display: "flex",
                      gap: 12,
                      marginBottom: 30,
                    }}
                  >
                    {["men", "women"].map((key) => (
                      <button
                        key={key}
                        type="button"
                        onClick={() => setPopularTab(key)}
                        style={{
                          padding: "10px 22px",
                          borderRadius: 999,
                          border:
                            popularTab === key
                              ? "1px solid #f43f5e"
                              : "1px solid #fbcfe8",
                          background:
                            popularTab === key
                              ? "linear-gradient(90deg, #f43f5e 0%, #fb7185 100%)"
                              : "#ffffff",
                          color: popularTab === key ? "#fff" : "#881337",
                          fontWeight: 700,
                          cursor: "pointer",
                          fontSize: 14,
                          boxShadow:
                            popularTab === key
                              ? "0 3px 10px rgba(244,63,94,0.25)"
                              : "0 1px 2px rgba(0,0,0,0.05)",
                          transition: "all .25s ease",
                        }}
                      >
                        {key === "men" ? "Men" : "Women"}
                      </button>
                    ))}
                  </div>

              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
                  gap: 26,
                }}
              >
                {(popularTab === "men" ? popular.men : popular.women).map(
                  (p) => (
                    <div
                      key={`pop-${p.id}`}
                      style={{
                        border: "1px solid #fbcfe8",
                        borderRadius: 20,
                        background: "#ffffff",
                        overflow: "hidden",
                        transition: "transform .25s ease, box-shadow .25s ease",
                        cursor: "pointer",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = "translateY(-6px)";
                        e.currentTarget.style.boxShadow =
                          "0 12px 28px rgba(244,63,94,0.15)";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = "none";
                        e.currentTarget.style.boxShadow =
                          "0 4px 14px rgba(244,63,94,0.08)";
                      }}
                    >
                      <div
                        style={{
                          position: "relative",
                          background: "#fff1f2",
                          aspectRatio: "1 / 1",
                          overflow: "hidden",
                        }}
                      >
                        <img
                          src={p.productImage}
                          alt={p.productName}
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            transition: "transform .4s ease",
                          }}
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = BrokenImage;
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.transform = "scale(1.05)";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.transform = "scale(1)";
                          }}
                        />
                        <div
                          style={{
                            position: "absolute",
                            top: 12,
                            left: 12,
                            background: "rgba(255,255,255,0.9)",
                            border: "1px solid #fecdd3",
                            padding: "5px 12px",
                            borderRadius: 999,
                            fontSize: 11,
                            fontWeight: 700,
                            color: "#be123c",
                            textTransform: "uppercase",
                            letterSpacing: 0.5,
                          }}
                        >
                          Featured
                        </div>
                      </div>

                      <div
                        style={{
                          padding: 18,
                          display: "flex",
                          flexDirection: "column",
                          height: "100%",
                        }}
                      >
                        <div
                          style={{
                            fontWeight: 800,
                            color: "#0f172a",
                            marginBottom: 6,
                            minHeight: 44,
                            lineHeight: "22px",
                            fontSize: 16,
                          }}
                        >
                          {p.productName || p.name}
                        </div>
                        <div
                          style={{
                            color: "#6b7280",
                            fontSize: 13,
                            marginBottom: 10,
                            minHeight: 36,
                          }}
                        >
                          {(p.description || "").slice(0, 90)}
                          {p.description && p.description.length > 90
                            ? "…"
                            : ""}
                        </div>

                        <div
                          style={{
                            fontSize: 18,
                            fontWeight: 800,
                            color: "#be123c",
                            marginBottom: 16,
                          }}
                        >
                          ${Number(p.basePrice || p.price || 0).toFixed(2)}
                        </div>

                        <Button
                          variant="contained"
                          style={{
                            background: "linear-gradient(90deg, #f43f5e 0%, #fb7185 100%)",
                            color: "#fff",
                            fontWeight: 700,
                            fontSize: 14,
                            textTransform: "none",
                            borderRadius: 10,
                          }}
                          onClick={() => navigate(`/register?procedure=store-consultation&productId=${p.id}`)}
                        >
                          Proceed to Buy
                        </Button>
                      </div>
                    </div>
                  )
                )}
                {(popularTab === "men" ? popular.men : popular.women).length ===
                  0 && (
                  <div
                    style={{
                      color: "#9ca3af",
                      textAlign: "center",
                      padding: "32px 0",
                    }}
                  >
                    No products to show
                  </div>
                )}
              </div>
              </>
              )}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default MyOrder;
